import axios from 'axios';
import { GoogleLogin } from '@react-oauth/google';

// import GoogleLoginButton from './GoogleLoginButton';


const SocialGoogle=({handleLogin})=>{

    // ---------------------------
    // 구글 로그인
    // ---------------------------
    const handleGoogleSuccess = async (credentialResponse) => {
        try {
            const idToken = credentialResponse.credential;
            const response = await axios.post('/googleauth/tokens', { provider: 'google', idToken });
            const { token, uuid , username} = response.data;
            handleLogin(token, uuid,username ); // handleLogin 호출
            // alert(response.data.message || 'Google Login Success!');
        } catch (err) {
            // console.error('Google Login Error:', err);
            alert(err.response?.data?.message || '로그인에 실패했습니다');
        }
    };

    // const handleGoogleSuccess = async (accessToken) => {
    //     try {
    //       const response = await axios.post('/googleauth/tokens', {
    //         provider: 'google',
    //         idToken: accessToken,
    //       });
    //       const { token, uuid, username, message } = response.data;
    //       handleLogin(token, uuid, username);
    //       alert(message || 'Google Login Success!');
    //     } catch (err) {
    //       console.error('Google Login Error:', err);
    //       alert(err.response?.data?.message || 'Google Login Error');
    //     }
    //   };
    const handleGoogleFailure = () => {
        alert('로그인에 실패했습니다');
    };
    // const handleGoogleFailure = (error) => {
    //     console.error('Google Login Failed:', error);
    //     alert('Google Login Failed');
    //   };

    return(
          <div className="social-button-container">
            <GoogleLogin
              onSuccess={handleGoogleSuccess}
              onError={handleGoogleFailure}
            />
          </div>

    );
    // return (
    //     <div>
    //       {/* 실제 커스텀 버튼 */}
    //       <GoogleLoginButton onSuccess={handleGoogleSuccess} onError={handleGoogleFailure} />
    //     </div>
    //   );
};

export default SocialGoogle
